import React from "react";
import { Box } from "@mui/material";
import { Theme } from "../../../../providers/ThemeProvider";
import useTheme from "../../../../common/hooks/useTheme";

type Props = {
  title: string;
  subtitle?: string;
};

const PageTitleSection = ({ title, subtitle }: Props) => {
  const theme: Theme = useTheme();

  return (
    <Box sx={styles.container}>
      <Box sx={styles.divider(theme)} />
      <Box component="p" sx={styles.title(theme)}>
        {title}
      </Box>
      {subtitle && (
        <Box component="p" sx={styles.subtitle(theme)}>
          {subtitle}
        </Box>
      )}
    </Box>
  );
};

export default PageTitleSection;

const styles = {
  container: {
    display: "flex",
    flexDirection: "column" as "column",
    gap: "4px",
  },
  divider: (theme: Theme) => ({
    width: "32px",
    height: "3px",
    backgroundColor: theme.colorTokens.P[90], // #04439C
  }),
  title: (theme: Theme) => ({
    fontFamily: "var(--font-Regular)",
    fontSize: "17px",
    lineHeight: "normal",
    color: theme.colorTokens.P[90], // #04439C
    margin: 0,
  }),
  subtitle: (theme: Theme) => ({
    fontFamily: "var(--font-Light)",
    fontSize: "11px",
    lineHeight: "normal",
    color: theme.colorTokens.N[80], // #6D7075
    margin: 0,
  }),
};
